var $ = jQuery

export default function WidgetPreview () {

  // Stop widget being added, when clicking link in the description.
  // Used when adding a preview link for the widgets
  $('body').on('click', 'a.so-widget-add', function () {
    const widgetPreviews = document.querySelectorAll('.so-panels-dialog-wrapper .widget-type .description > a')
    if (widgetPreviews.length > 0) {
      for (let i = 0; i < widgetPreviews.length; i++) {
        widgetPreviews[i].addEventListener('click', (e) => e.stopPropagation())
      }
    }
  })
}